import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Button, Typography, Box } from "@mui/material";
import { useSearchParams } from "react-router-dom";
import { getDataFromCmsApi } from "../../api/contentful-service";
import SubmitContactFormModal from "./submit-contact-form-modal";
import PhoneDirectoryModal from "./phone-directory-modal";
import ButtonCard from "../cards/button-card/button-card";

const ContactUsButtonCard = ({ phoneDirectory, cardColor, cardData }) => {
    const [searchParams] = useSearchParams();
    const divisionParam = searchParams.get("division") || "";
    const queryParam = searchParams.get("query") || "";

    const [chat, setChat] = useState(
        process.env.REACT_APP_ZENDESK_ENABLED === 'true'
    );

    const [isLoading, setIsLoading] = useState(true);
    const [form, setForm] = useState([]);
    const [openModal, setOpenModal] = useState(
        cardData.id === "submitContactForm" && (divisionParam !== "" || queryParam !== "") ? true : false
    );

    useEffect(() => {
        cardData.id === "submitContactForm" && getFormData().then(() => setIsLoading(false));
    }, []);

    const getFormData = async () => {
        const result = await getDataFromCmsApi(`Form/contact-us`);
        setForm(result[0]);
    };

    const handleOpenModal = () => {
        setOpenModal(true);
    };

    const handleCloseModal = () => {
        setOpenModal(false);
    };

    return (
        <ButtonCard
            cardColor={cardColor}
            cardData={cardData}
            customButtonComponent={
                cardData.id === "submitContactForm" ? (
                    <>
                        <Button variant="contained" onClick={handleOpenModal}>
                            {cardData.buttonText}
                        </Button>
                        <SubmitContactFormModal
                            openModal={openModal}
                            handleCloseModal={handleCloseModal}
                            isLoading={isLoading}
                            form={form}
                        />
                    </>
                ) : cardData.id === "chatWithUs" ? (
                    <Box>
                    <Button      
                    style={{ display: chat ? '' : 'none' }}
                        variant="contained"
                        onClick={() => {
                            if (window.zE) {
                                window.zE("messenger", "open");
                            } else {
                                console.error("Zendesk widget is not loaded");
                            }
                        }}
                    >
                        {cardData.buttonText}
                    </Button>
                      {!chat && (
                        <Typography>
                          Chat is unavailable at this time. You may submit a Contact Form.
                        </Typography>
                      )}
                      </Box>
                ) : cardData.id === "phone" ? (
                    <>
                        <Button variant="contained" onClick={handleOpenModal}>
                            {cardData.buttonText}
                        </Button>
                        <PhoneDirectoryModal
                            openModal={openModal}
                            handleCloseModal={handleCloseModal}
                            phoneDirectory={phoneDirectory}
                        />
                    </>
                ) : null
            }
        />
    );
};

ContactUsButtonCard.propTypes = {
    phoneDirectory: PropTypes.object,
    cardColor: PropTypes.string,
    cardData: PropTypes.object
};

export default ContactUsButtonCard;
